@import 'src/styles/fonts';
@import 'src/styles/deviceBreakpoints';

.statusColumn {
  width: 45%;
}

.stedColumn {
  width: 50%;
}

.actionColumn {
  width: 5%;
}

.tableCellContent {
  display: flex;
  align-items: center;

  .studiestedNavn {
    display: inline-flex;
    align-items: center;

    .icon {
      margin-right: 0.33em;
    }
  }
}

.searchField {
  margin-top: 1em;
}

.btnGroup {
  display: inline-flex;
  justify-content: space-between;
  width: 16em;

  .btn {
    width: 7.5em;
    min-width: 7.5em;
  }
}

.inputFieldRow {
  display: flex;
  justify-content: space-between;
  margin-top: 1em;

  .textInput {
    width: 45%;
  }
}

.selectAllCheckbox {
  vertical-align: bottom !important;
}
